const deferredActionVisibilityById: Record<string, boolean> = {}
const deferredActionEnabledById: Record<string, boolean> = {}
const deferredActionTitleById: Record<string, string> = {}
const deferredPanelVisibilityById: Record<string, boolean> = {}

export function rememberDeferredActionVisibility(actionId: string | number, visible: boolean): void {
  const key = String(actionId).trim()
  if (!key) return
  deferredActionVisibilityById[key] = visible
}

export function takeDeferredActionVisibility(actionId: string | number): boolean | undefined {
  const key = String(actionId).trim()
  if (!key) return undefined
  const visible = deferredActionVisibilityById[key]
  if (visible === undefined) return undefined
  delete deferredActionVisibilityById[key]
  return visible
}

/** Читает deferred visibility без удаления (inline-меню TreeTable без mount MAction). */
export function peekDeferredActionVisibility(actionId: string | number): boolean | undefined {
  const key = String(actionId).trim()
  if (!key) return undefined
  return deferredActionVisibilityById[key]
}

export function rememberDeferredActionEnabled(actionId: string | number, enabled: boolean): void {
  const key = String(actionId).trim()
  if (!key) return
  deferredActionEnabledById[key] = enabled
}

export function takeDeferredActionEnabled(actionId: string | number): boolean | undefined {
  const key = String(actionId).trim()
  if (!key) return undefined
  const enabled = deferredActionEnabledById[key]
  if (enabled === undefined) return undefined
  delete deferredActionEnabledById[key]
  return enabled
}

export function rememberDeferredActionTitle(actionId: string | number, title: string): void {
  const key = String(actionId).trim()
  if (!key) return
  deferredActionTitleById[key] = title == null ? '' : String(title)
}

export function takeDeferredActionTitle(actionId: string | number): string | undefined {
  const key = String(actionId).trim()
  if (!key) return undefined
  if (!Object.prototype.hasOwnProperty.call(deferredActionTitleById, key)) return undefined
  const title = deferredActionTitleById[key]
  delete deferredActionTitleById[key]
  return title
}

export function rememberDeferredPanelVisibility(panelId: string | number, visible: boolean): void {
  const key = String(panelId).trim()
  if (!key) return
  deferredPanelVisibilityById[key] = visible
}

export function takeDeferredPanelVisibility(panelId: string): boolean | undefined {
  const key = String(panelId).trim()
  if (!key) return undefined
  const visible = deferredPanelVisibilityById[key]
  if (visible === undefined) return undefined
  delete deferredPanelVisibilityById[key]
  return visible
}

export function clearDeferredFormVisibilityForActionIds(actionIds: Array<string | number>): void {
  for (const rawId of actionIds) {
    const key = String(rawId ?? '').trim()
    if (!key) continue
    delete deferredActionVisibilityById[key]
    delete deferredActionEnabledById[key]
    delete deferredActionTitleById[key]
  }
}

export function snapshotDeferredActionVisibility(): Record<string, boolean> {
  return { ...deferredActionVisibilityById }
}

/** Восстанавливает deferred visibility после preview onInlineMenuShow. */
export function restoreDeferredActionVisibility(
  snapshot: Record<string, boolean>,
  actionIds: Array<string | number>,
): void {
  for (const rawId of actionIds) {
    const key = String(rawId ?? '').trim()
    if (!key) continue
    delete deferredActionVisibilityById[key]
    if (Object.prototype.hasOwnProperty.call(snapshot, key)) {
      deferredActionVisibilityById[key] = snapshot[key]
    }
  }
}

export function clearAllDeferredFormVisibility(): void {
  for (const key of Object.keys(deferredActionVisibilityById)) {
    delete deferredActionVisibilityById[key]
  }
  for (const key of Object.keys(deferredActionEnabledById)) {
    delete deferredActionEnabledById[key]
  }
  for (const key of Object.keys(deferredActionTitleById)) {
    delete deferredActionTitleById[key]
  }
  for (const key of Object.keys(deferredPanelVisibilityById)) {
    delete deferredPanelVisibilityById[key]
  }
}
